import { API_ROOT } from '../config/ApiConfig';
import { generateRequestHeaders } from '../service/ApiService';
import { SearchResourcesResponse } from './ResourcesAPI';

export async function getLeadsSummary(
  customerId: string,
  limit: number,
  offset: number
): Promise<SearchResourcesResponse> {
  const endpoint = `${API_ROOT}/leads/summary?customer-id=${encodeURIComponent(customerId)}&limit=${limit}&offset=${offset}`;
  const response = await fetch(endpoint, {
    headers: generateRequestHeaders()
  });
  const data = await response.json();

  if (response.status === 200) {
    const pageNo = limit > 0 ? Math.floor(offset / limit) + 1 : 1;
    return {
      totalCount: data.totalCount || 0,
      count: data.count || 0,
      pageNo: pageNo,
      data: data.leads || [],
      httpstatus: response.status,
      reason: '',
      message: ''
    };
  }

  return {
    totalCount: 0,
    count: 0,
    pageNo: 1,
    data: [],
    httpstatus: response.status,
    reason: data.reason || '',
    message: data.message || 'Failed to fetch leads'
  };
}

export async function captureLead(request: object): Promise<any> {
  const endpoint = `${API_ROOT}/leads/capture-lead`;
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: generateRequestHeaders(),
    body: JSON.stringify(request)
  });
  const data = await response.json();
  data.httpstatus = response.status;
  return data;
}
